module.exports = __webpack_public_path__ + "static/img/yx6.8dd732d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yx6.jpg
// module id = Piu9
// module chunks = 1